















import { defineComponent } from '@vue/composition-api';
import { ValidationProvider } from 'vee-validate';
import { inputProps, useDisplayLabel } from '../../formUtils';
import rules from '../../rules';

rules();

export default defineComponent({
	components: { ValidationProvider },
	props: {
		...inputProps,
	},
	setup(props) {
		const { displayLabel } = useDisplayLabel(props);
		return { displayLabel };
	},
});
